let messages = {
  index1: 'English',
  index2: 'Log Out',
  index3: 'Home',
  index4: 'Account Information',
  index5: 'Deposit',
  index6: 'Withdrawal',
  index7: 'Transfer',
  index8: 'Wallet',
  index9: 'Cash Account(MEQ)',
  index10: 'Agent Information',
  index11: 'Sub-agent Number',
  index12: 'User Number',
  index13: 'Add Sub-agent',
  index14: 'Invite Link',
  index15: 'Copy Link',
  index16: 'To do list',
  index17: 'Customer Profile Details',
  index18: 'Apply for withdrawal',
  index19: 'Apply for deposit',
  index20: 'My Profile',
  index21: 'User name',
  index22: 'Agent ID',
  index23: 'Registration Time',
  index24: 'Email',
  index25: 'Login password',
  index26: 'Bank Information',
  index27: 'Account Holder',
  index28: 'Bank Name',
  index29: 'Card Account Number',
  index30: 'Reset Password',
  index31: 'Please enter your current password',
  index32: 'Please enter your new password',
  index33: 'Submit',
  index34: 'Modify bank card information',
  index35: 'Notifications',
  index36: 'Transfer Successful',
  index37: 'Deposit Successful',
  index38: 'Withdrawal Successful',
  my1: 'English',
  my2: 'Log Out',
  my3: 'My Funds',
  my4: 'Deposit',
  my5: 'Deposit Report',
  my6: 'Deposit Type',
  my7: 'Cash Deposit',
  my8: 'Cash Account',
  my9: 'Dollars',
  my10: 'Amount',
  my11: 'USDT to MEQ Exchange Rate',
  my12: 'Amount({n})',
  my13: 'Deposit Receipt',
  my14: 'Please enter the deposit amount',
  my15: 'Please enter the Transaction Hash',
  my16: 'Wallet(MEQ)',
  my17: 'Transfer-Out Amount',
  my18: 'Receiving Bank',
  my19: 'Account Holder',
  my20: 'Bank Name',
  my21: 'Card Account Number',
  my22: 'Submit',
  my23: 'Submission Successful',
  my24: 'The order will be reviewed and processed within 1-2 business days',
  my25: 'Confirm',
  my26: 'Transfer successful',
  my27: 'Transfer',
  my28: 'Transfer Report',
  my29: 'Recipient',
  my30: 'Agent',
  my31: 'User',
  my32: 'Payee ID',
  my33: 'Please enter the payee ID',
  my34: 'User ID',
  my35: 'Please enter the User ID',
  my36: 'Recipient Username',
  my37: 'Cash Account(MEQ)',
  my38: 'Dollar',
  my39: 'Transfer Amount',
  my40: 'Please enter the Transfer Amount.',
  my41: 'Submit',
  my42: 'Transfer Successful',
  my43: 'Confirm',
  my44: 'Withdrawal',
  my45: 'Withdrawal Records',
  my46: 'Cash Account Balance',
  my47: 'Dollar',
  my48: 'Withdrawal Amount',
  my49: 'Please enter the Withdrawal Amount',
  my50: 'Exchange Rate',
  my51: 'Amount({n})',
  my52: 'Receiving Bank',
  my53: 'Submission Successful',
  my54: 'Your withdrawal request has been submitted, and we will process it within 1 to 2 business days',
  my55: 'Confirm',
  my56: 'Reminder',
  my57: 'You have not yet verified your bank card information. Please complete the bank card information before withdrawal.',
  my58: 'Cancel',
  my59: 'Complete Immediately',
  my60: 'Submit',
  my61: 'Wallet(MEQ)',
  my62: 'Transfer Amount(MEQ)',
  my63: 'Please enter the Transfer Amount',
  my64: 'Transfer Wallet Balance to Cash Account',
  my65: 'Submit',
  my66: 'Reference No',
  my67: 'Wallet Balance(MEQ)',
  my68: 'Transfer Amount(MEQ)',
  my69: 'Cash Account',
  my70: 'Time',
  my71: 'Instructions',
  my72: 'Commission Income',
  my73: 'Transfer to cash account',
  my74: 'Total {n} results',
  my75: 'Jump To Page  {n}',
  my76: 'Transfer successful',
  my77: 'Confirm',
  my78: 'Deposit Report',
  my79: 'Status',
  my80: 'All',
  my81: 'Pending Approval',
  my82: 'Approval Successful',
  my83: 'Approval Unsuccessful',
  my84: 'Deposit Time',
  my85: 'Search',
  my86: 'Reference No',
  my87: 'Amount(MEQ)',
  my201: 'Amount (MEQ)',
  my88: 'Amount(USDT)',
  my89: 'Exchange Rate',
  my90: 'Cash Account Balance(MEQ)',
  my91: 'Time',
  my92: 'Deposit Receipt',
  my93: 'Number',
  my94: 'Remark',
  my95: 'Status',
  my96: 'Operate',
  my97: 'Details',
  my98: 'Close',
  my99: 'Total {n} results',
  my100: '{n} items/page',
  my101: 'Jump To Page  {n}',
  my102: 'Withdrawal Report',
  my103: 'Status',
  my104: 'All',
  my105: 'Pending Approval',
  my106: 'Approval Successful',
  my107: 'Approval Unsuccessful',
  my108: 'Withdrawal Time',
  my109: 'Search',
  my110: 'Reference No',
  my111: 'Amount(USDT)',
  my112: 'Amount (MEQ)',
  my113: 'Exchange Rate',
  my114: 'Cash Account Balance(MEQ)',
  my115: 'Withdrawal Time',
  my116: 'Remark',
  my117: 'Status',
  my118: 'Operate',
  my119: 'Details',
  my120: 'Close',
  my121: 'Total {n} results',
  my122: '{n} items/page',
  my123: 'Jump To Page  {n}',
  my124: 'Transfer Report',
  my125: 'Recipient',
  my126: 'All',
  my127: 'Agent',
  my128: 'User',
  my129: 'Transfer Type',
  my130: 'All',
  my131: 'Transfer In',
  my132: 'Transfer Out',
  my133: 'Payee ID',
  my134: 'The Agent ID',
  my135: 'Time',
  my136: 'Search',
  my137: 'Export',
  my138: 'Reference No',
  my139: 'Recipient',
  my140: 'Payee ID',
  my141: 'Amount(MEQ)',
  my142: 'Cash Account Balance',
  my143: 'Transfer Type',
  my144: 'Transfer Time',
  my145: 'Total X results',
  my146: 'x items/page',
  my147: 'Jump To Page  X',
  my148: 'Payee ID',
  my149: 'Payee Name',
  my150: 'Please enter the payee ID',
  my151: 'The Payee ID',
  my152: 'The user ID',
  my153: 'Agent ID / Upline Agent ID',
  my154: 'Transfer Time',
  my155: 'Tether (USDT)',
  my156: 'Amount(MEQ)',
  my157: 'Remarks',
  my401: 'Balance Before(MEQ)',
  proxymoney1: 'English',
  proxymoney2: 'Log Out',
  proxymoney3: 'Fund Review',
  proxymoney4: 'Sub-Agent Deposit Review',
  proxymoney5: 'Status',
  proxymoney6: 'All',
  proxymoney7: 'Approval Successful',
  proxymoney8: 'Approval Unsuccessful',
  proxymoney9: 'Agent ID',
  proxymoney10: 'Please enter Agent ID / Upline Agent ID',
  proxymoney11: 'Deposit Time',
  proxymoney12: 'Search',
  proxymoney13: 'Export',
  proxymoney14: 'Reference No',
  proxymoney15: 'User Name',
  proxymoney16: 'Agent ID',
  proxymoney17: 'Superior Agent ID',
  proxymoney18: 'Amount ({n})',
  proxymoney19: 'Amount ($)',
  proxymoney20: 'Exchange Rate',
  proxymoney21: 'Cash Account Balance',
  proxymoney22: 'Deposit Time',
  proxymoney23: 'Deposit Receipt',
  proxymoney24: 'Remark',
  proxymoney25: 'Status',
  proxymoney26: 'Operate',
  proxymoney27: 'Approval',
  proxymoney28: 'Details',
  proxymoney29: 'Pass',
  proxymoney30: 'Failed',
  proxymoney31: 'Serial Number',
  proxymoney32: 'Please enter your approval opinions',
  proxymoney33: 'Status',
  proxymoney34: 'Confirm',
  proxymoney35: 'Cancel',
  proxymoney36: 'Total X results',
  proxymoney37: 'x items/page',
  proxymoney38: 'Jump To Page X',
  proxymoney39: 'Status',
  proxymoney40: 'All',
  proxymoney41: 'Approval Successful',
  proxymoney42: 'Approval Unsuccessful',
  proxymoney43: 'Agent ID',
  proxymoney44: 'Please enter the agent name',
  proxymoney45: 'Withdrawal Time',
  proxymoney46: 'Search',
  proxymoney47: 'Export',
  proxymoney48: 'Reference No',
  proxymoney49: 'User Name',
  proxymoney50: 'Agent ID',
  proxymoney51: 'Superior Agent ID',
  proxymoney52: 'Amount ({n})',
  proxymoney201: 'Amount(USDT)',
  proxymoney53: 'Amount(MEQ)',
  proxymoney54: 'Exchange Rate',
  proxymoney55: 'Cash Account Balance(MEQ)',
  proxymoney56: 'Withdrawal Time',
  proxymoney57: 'Remark',
  proxymoney58: 'Status',
  proxymoney59: 'Operate',
  proxymoney60: 'Approval',
  proxymoney61: 'Details',
  proxymoney62: 'Bank Information',
  proxymoney63: 'Account Holder',
  proxymoney64: 'Bank Name',
  proxymoney65: 'Card Account Number',
  proxymoney66: 'Branch Name',
  proxymoney67: 'Pass',
  proxymoney68: 'Failed',
  proxymoney69: 'Cancel',
  proxymoney70: 'Confirm',
  proxymoney71: 'Please enter your approval opinions',
  proxymoney72: 'Close',
  proxymoney73: 'Status',
  proxymoney74: 'Total X results',
  proxymoney75: 'x items/page',
  proxymoney76: 'Jump To Page X',
  proxymoney77: 'Customer Deposit Review',
  proxymoney78: 'Status',
  proxymoney79: 'All',
  proxymoney80: 'Approval Successful',
  proxymoney81: 'Approval Unsuccessful',
  proxymoney82: 'User ID / Superior Agent ID',
  proxymoney83: 'Please enter Customer ID / Upline Agent ID',
  proxymoney84: 'Deposit Time',
  proxymoney85: 'Search',
  proxymoney86: 'Export',
  proxymoney87: 'Reference No',
  proxymoney88: 'User Name',
  proxymoney89: 'User ID',
  proxymoney90: 'Superior Agent ID',
  proxymoney91: 'Amount ({n})',
  proxymoney92: 'Amount ($)',
  proxymoney93: 'Actual Amount ($)',
  proxymoney94: 'Exchange Rate',
  proxymoney95: 'Cash Account Balance',
  proxymoney96: 'Deposit Time',
  proxymoney97: 'Deposit Receipt',
  proxymoney98: 'Serial Number',
  proxymoney99: 'Remark',
  proxymoney100: 'Status',
  proxymoney101: 'Operate',
  proxymoney102: 'Approval',
  proxymoney103: 'Modify',
  proxymoney104: 'Cancel',
  proxymoney105: 'Confirm',
  proxymoney106: 'Status',
  proxymoney107: 'Close',
  proxymoney108: 'Please enter your approval opinions',
  proxymoney109: 'Confirm',
  proxymoney110: 'Cancel',
  proxymoney111: 'Please enter the amount',
  proxymoney112: 'Total X results',
  proxymoney113: 'x items/page',
  proxymoney114: 'Jump To Page X',
  proxymoney115: 'Customer Withdrawal Review',
  proxymoney116: 'Status',
  proxymoney117: 'All',
  proxymoney118: 'Approval Successful',
  proxymoney119: 'Approval Unsuccessful',
  proxymoney120: 'User ID / Superior Agent ID',
  proxymoney121: 'Please enter Customer ID / Upline Agent ID',
  proxymoney122: 'Withdrawal Time',
  proxymoney123: 'Search',
  proxymoney124: 'Export',
  proxymoney125: 'Reference No',
  proxymoney126: 'User Name',
  proxymoney127: 'User ID',
  proxymoney128: 'Superior Agent ID',
  proxymoney129: 'Amount (X)',
  proxymoney130: 'Amount ($)',
  proxymoney131: 'Exchange Rate',
  proxymoney132: 'Withdrawal Time',
  proxymoney133: 'Remark',
  proxymoney134: 'Status',
  proxymoney135: 'Operate',
  proxymoney136: 'Approval',
  proxymoney137: 'Details',
  proxymoney138: 'Bank Information',
  proxymoney139: 'Account Holder',
  proxymoney140: 'Bank Name',
  proxymoney141: 'Card Account Number',
  proxymoney142: 'Branch Name',
  proxymoney143: 'Pass',
  proxymoney144: 'Failed',
  proxymoney145: 'Cancel',
  proxymoney146: 'Confirm',
  proxymoney147: 'Please enter your approval opinions',
  proxymoney148: 'Close',
  proxymoney149: 'Status',
  proxymoney150: 'Total X results',
  proxymoney151: 'x items/page',
  proxymoney152: 'Jump To Page X',
  proxyproxy1: 'English',
  proxyproxy2: 'Log Out',
  proxyproxy3: 'Sub-agent Management',
  proxyproxy4: 'Sub-agent List',
  proxyproxy5: 'Username / Agent ID',
  proxyproxy6: 'The name or sub-agent ID',
  proxyproxy7: 'Search',
  proxyproxy8: 'Export',
  proxyproxy9: 'Create a sub-agent',
  proxyproxy10: 'User name',
  proxyproxy11: 'Please enter the username of the sub-agent',
  proxyproxy12: 'Email',
  proxyproxy13: 'Please enter the user\'s valid email',
  proxyproxy14: 'Login password',
  proxyproxy15: 'Use a combination of numbers and English letters, 8 to 16 characters',
  proxyproxy16: 'Commission Ratio (Fee)',
  proxyproxy17: 'Please enter the Commission Ratio (Fee)',
  proxyproxy18: 'Less than or equal to {n}%',
  proxyproxy19: 'Commission Ratio (interest)',
  proxyproxy20: 'Please enter the Commission Ratio (interest)',
  proxyproxy21: 'Less than or equal to {n}%',
  proxyproxy22: 'Sub-agent ID',
  proxyproxy23: 'Superior Agent ID',
  proxyproxy24: 'Agent Type',
  proxyproxy25: 'Channel Agent',
  proxyproxy26: 'Agent Level',
  proxyproxy27: 'Commission Ratio (Fee)',
  proxyproxy28: 'Commission Ratio (interest)',
  proxyproxy29: 'Wallet Balance(MEQ)',
  proxyproxy30: 'Cash Account Balance(MEQ)',
  proxyproxy31: 'Registration Time',
  proxyproxy32: 'Operate',
  proxyproxy33: 'Modify',
  proxyproxy34: 'Cancel',
  proxyproxy35: 'Invite Users',
  proxyproxy36: 'Confirm',
  proxyproxy37: 'Total {n} results',
  proxyproxy38: '{n} items/page',
  proxyproxy39: 'Jump To Page {n}',
  proxyproxy40: 'Sub-agent Earning Report',
  proxyproxy41: 'Username / Agent ID',
  proxyproxy42: 'Please enter the username or agent ID',
  proxyproxy43: 'Search',
  proxyproxy44: 'Export',
  proxyproxy45: 'User Name',
  proxyproxy46: 'Agent ID',
  proxyproxy47: 'Superior Agent ID',
  proxyproxy48: 'Number of users',
  proxyproxy49: 'Total Deposit(MEQ)',
  proxyproxy50: 'Total withdrawal(MEQ)',
  proxyproxy51: 'Trading Volume ({n})',
  proxyproxy52: 'Commission ({n})',
  proxyproxy53: 'Funding Fee ({n})',
  proxyproxy54: 'Total {n} results',
  proxyproxy55: '{n} items/page',
  proxyproxy56: 'Jump To Page {n}',
  proxyproxy57: 'All users can develop direct referrals through invitations, and agent levels are upgraded automatically by the system.',
  proxyproxy58: 'After meeting the upgrade conditions, users advance to Level 3 Agent, Level 2 Agent, and Level 1 Agent in sequence.',
  proxyproxy59: 'Agent commissions are settled according to platform rules and actual trading data.',
  proxyproxy60: 'Agent created successfully',
  proxyproxy61: 'Agent information updated',
  proxyproxy62: 'Please enter a valid rate',
  proxycust1: 'English',
  proxycust2: 'Log Out',
  proxycust3: 'User Management',
  proxycust4: 'User Name / User ID / Trading Account',
  proxycust5: 'Please Enter',
  proxycust6: 'Status',
  proxycust7: 'All',
  proxycust8: 'Approval Successful',
  proxycust9: 'Approval Unsuccessful',
  proxycust10: 'Search',
  proxycust11: 'Export',
  proxycust12: 'Create Customer',
  proxycust13: 'User Name',
  proxycust14: 'Please enter the User Name',
  proxycust15: 'User ID',
  proxycust16: 'Login Password',
  proxycust17: '8 to 16 characters of numbers and letters combination',
  proxycust18: 'Leverage (DT)',
  proxycust19: 'Please enter the Leverage(DT)',
  proxycust20: 'Leverage (LTT)',
  proxycust21: 'Please enter the Leverage  (LTT)',
  proxycust22: 'Cancel',
  proxycust23: 'Create User Name',
  proxycust24: 'User Name',
  proxycust25: 'User ID',
  proxycust26: 'Trading Account',
  proxycust27: 'Leverage (DT)',
  proxycust28: 'Leverage  (LTT)',
  proxycust29: 'Cash Account Balance (MEQ)',
  proxycust30: 'Trading Account Balance (MEQ)',
  proxycust31: 'First Deposit Time',
  proxycust32: 'Registration Time',
  proxycust33: 'Status',
  proxycust34: 'Operate',
  proxycust35: 'Approval',
  proxycust36: 'Details',
  proxycust37: 'Pass',
  proxycust38: 'Failed',
  proxycust39: 'Remark',
  proxycust40: 'Please enter your approval opinions',
  proxycust41: 'Close',
  proxycust42: 'Cancel',
  proxycust43: 'Confirm',
  proxycust44: 'Identity Information',
  proxycust45: 'ID Card Front',
  proxycust46: 'ID Card Back',
  proxycust47: 'Total X results',
  proxycust48: 'x items/page',
  proxycust49: 'Jump To Page X',
  proxycust50: 'Trading Fees Report',
  proxycust51: 'User Name / Trading Account',
  proxycust52: 'Please enter name / trading account',
  proxycust53: 'Trading Account Type',
  proxycust54: 'DT Account',
  proxycust55: 'LTT Account',
  proxycust56: 'Execution Time',
  proxycust57: 'Search',
  proxycust58: 'Export',
  proxycust59: 'User Name',
  proxycust60: 'Trading Account',
  proxycust61: 'Trading Account Type',
  proxycust62: 'Trading Fees',
  proxycust63: 'Reference No',
  proxycust64: 'Execution Time',
  proxycust65: 'Total X results',
  proxycust66: 'x items/page',
  proxycust67: 'Jump To Page x',
  proxycust68: 'User Trading Record',
  proxycust69: 'Execution Time',
  proxycust70: 'Open / Close',
  proxycust71: 'Open',
  proxycust72: 'Close',
  proxycust73: 'Buy / Sell',
  proxycust74: 'Buy',
  proxycust75: 'Sell',
  proxycust76: 'All',
  proxycust77: 'Trading Product',
  proxycust78: 'Please enter the trading product',
  proxycust79: 'User Name / Trading Account',
  proxycust80: 'Please enter name / trading account',
  proxycust81: 'Search',
  proxycust82: 'Export',
  proxycust83: 'Total P/L ($)',
  proxycust84: 'User Name',
  proxycust85: 'Trading Account',
  proxycust86: 'Order ID',
  proxycust87: 'Product',
  proxycust88: 'Price',
  proxycust89: 'Open / Close',
  proxycust90: 'Buy / Sell',
  proxycust91: 'Quantity',
  proxycust92: 'Fee ($)',
  proxycust93: 'Profit',
  proxycust94: 'Execution Time',
  proxycust95: 'Total X results',
  proxycust96: 'x items/page',
  proxycust97: 'Jump To Page X',
  proxycust98: 'Long-term Trading Report',
  proxycust99: 'Execution Time',
  proxycust100: 'Open / Close',
  proxycust101: 'Open',
  proxycust102: 'Close',
  proxycust103: 'Buy / Sell',
  proxycust104: 'Buy',
  proxycust105: 'Sell',
  proxycust106: 'All',
  proxycust107: 'Trading Product',
  proxycust108: 'Please enter the trading product',
  proxycust109: 'User Name / Trading Account ID',
  proxycust110: 'The name or trading account ID',
  proxycust111: 'Search',
  proxycust112: 'Export',
  proxycust113: 'Total P/L ($)',
  proxycust114: 'User Name',
  proxycust115: 'Trading Account',
  proxycust116: 'Order ID',
  proxycust117: 'Product',
  proxycust118: 'Price',
  proxycust119: 'Open / Close',
  proxycust120: 'Buy / Sell',
  proxycust121: 'Quantity',
  proxycust122: 'Interest ($)',
  proxycust123: 'Profit',
  proxycust124: 'Execution Time',
  proxycust125: 'Total X results',
  proxycust126: 'x items/page',
  proxycust127: 'Jump To Page x',
  proxycust128: 'The name or user ID or trading account',
  proxymoneymanage1: 'English',
  proxymoneymanage2: 'Log Out',
  proxymoneymanage3: 'Fund Management',
  proxymoneymanage4: 'User Transfer Report',
  proxymoneymanage5: 'Name/ Trade Account ID',
  proxymoneymanage6: 'Please enter the  Name/ Trade Account ID',
  proxymoneymanage7: 'Transfer Type',
  proxymoneymanage8: 'All',
  proxymoneymanage9: 'Deposit',
  proxymoneymanage10: 'Withdrawa',
  proxymoneymanage11: 'Transfer Time',
  proxymoneymanage12: 'Search',
  proxymoneymanage13: 'Export',
  proxymoneymanage14: 'Reference No',
  proxymoneymanage15: 'Name',
  proxymoneymanage16: 'Trading Account',
  proxymoneymanage17: 'Amount($)',
  proxymoneymanage18: 'Amount({n})',
  proxymoneymanage19: 'Exchange Rate',
  proxymoneymanage20: 'Transfer Type',
  proxymoneymanage21: 'Transfer Time',
  proxymoneymanage22: 'Total X results',
  proxymoneymanage23: 'x items/page',
  proxymoneymanage24: 'Jump To Page X',
  proxymoneymanage25: 'Commission Report',
  proxymoneymanage26: 'Name / ID / Trading Account ID',
  proxymoneymanage27: 'Please enter',
  proxymoneymanage28: 'Trading Account Type',
  proxymoneymanage29: 'All',
  proxymoneymanage30: 'DT',
  proxymoneymanage31: 'LTT',
  proxymoneymanage32: 'Filled Time',
  proxymoneymanage33: 'Search',
  proxymoneymanage34: 'Export',
  proxymoneymanage35: 'Agent Username',
  proxymoneymanage36: 'Agent ID',
  proxymoneymanage37: 'Agent Level',
  proxymoneymanage38: 'Account Type',
  proxymoneymanage39: 'Commission rate',
  proxymoneymanage40: 'Fees (MEQ)',
  proxymoneymanage41: 'Fees ({n})',
  proxymoneymanage42: 'Exchange Rate',
  proxymoneymanage43: 'Commission(MEQ)',
  proxymoneymanage44: 'User ID',
  proxymoneymanage45: 'Trading Account ID',
  proxymoneymanage46: 'Symbol',
  proxymoneymanage47: 'Quantity',
  proxymoneymanage48: 'Fill Price',
  proxymoneymanage49: 'Open / Close',
  proxymoneymanage50: 'Open',
  proxymoneymanage51: 'Close',
  proxymoneymanage52: 'Buy / Sell',
  proxymoneymanage53: 'Buy',
  proxymoneymanage54: 'Sell',
  proxymoneymanage55: 'Reference No',
  proxymoneymanage56: 'Filled Time',
  proxymoneymanage57: 'Total X results',
  proxymoneymanage58: 'x items/page',
  proxymoneymanage59: 'Jump To Page X',
  proxymoneymanage60: 'Amount (MEQ)',
  proxymoneymanage61: 'Amount({n})',
  proxymoneymanage62: 'The name or ID or Trading Account ID',
  proxymoneymanage63: 'Trading Account Type',
  proxymoneymanage64: 'Day-Trading Account',
  proxymoneymanage65: 'Financing Trading Account',
  user1: 'English',
  user2: 'Log Out',
  user3: 'Log in',
  user4: 'Please enter your username',
  user5: 'User ID',
  user6: '8 to 16 characters alphanumeric',
  user7: 'Confirm Password',
  user8: 'Please enter your E-mail(Optional)',
  user9: 'Please enter your phone number(Optional)',
  user10: 'Invitation Code',
  user11: 'Sign Up',
  user12: 'Already have an account? Log in',
  user13: 'The username already exists. Please enter a different username.',
  user14: 'The password format is incorrect. Please enter a password with 8-16 letters and numbers',
  user15: 'Confirm password input error',
  user16: 'Incorrect email verification code.',
  user17: 'By signing up, you agree to our User Agreement and Privacy Policy',
  user18: 'Manual Verification',
  user19: 'Please click the letters in the image in order',
  user20: 'Reload',
  user21: 'Submit Verification',
  user22: 'Verification failed. Please try again.',
  user23: 'Log In',
  user24: 'Your username/ user ID',
  user25: 'Please enter password',
  user26: 'Sign In',
  user27: 'Home',
  user28: 'Account Information',
  user29: 'Deposit',
  user30: 'Withdrawal',
  user31: 'Transfer',
  user32: 'Cash Account Balance (MEQ)',
  user33: 'Total Account Value',
  user34: 'Total Assets = Cash Account Balance + Day-Trading Account Equity + Financing Trading Account Equity',
  user35: 'Trading Account Information',
  user36: 'Trading Account Number',
  user37: 'Trading Account Password',
  user38: 'Copy',
  user39: 'Trading Account Overview',
  user40: 'Trading Accounts Deposit',
  user41: 'Trading Account Withdrawal',
  user42: 'Trading Account ID',
  user43: 'Leverage',
  user44: 'Account Equity(MEQ)',
  user45: 'LTT',
  user46: 'Financing Multiplier',
  user47: '{n}x',
  user48: 'Account Balance ($)',
  user49: 'My Profile',
  user50: 'Username',
  user51: 'User ID',
  user52: 'Trading Account Number',
  user53: 'Registration Time',
  user54: 'Email',
  user55: 'Login Password',
  user56: 'Phone Number',
  user57: 'Identity Information',
  user58: 'ID card',
  user59: 'ID card',
  user60: 'Bank Information',
  user61: 'Account Holder',
  user62: 'Bank Name',
  user63: 'Bank Card Number',
  user64: 'Supplementary Information',
  user65: 'Not Complete',
  user66: 'Please enter the name of the account holder',
  user67: 'Please enter the bank name',
  user68: 'Please enter the bank card number',
  user69: 'Please enter the branch name',
  user70: 'Cancel',
  user71: 'Confirm',
  user72: 'Modify username',
  user73: 'Old username',
  user74: 'Please enter a new username',
  user75: 'Modify Mobile Number',
  user76: 'Old Mobile Number',
  user77: 'Please enter the new mobile number',
  user78: 'Email modification',
  user79: 'Old Email',
  user80: 'Please enter a new email address',
  user81: 'Change Password',
  user82: 'Please enter old password',
  user83: 'Please enter a new password',
  user84: 'Submit',
  user85: 'Modify Mobile Number',
  user86: 'Modify bank card information',
  user87: 'Notifications',
  user88: 'Transfer  Successful',
  user89: 'Deposit Successful',
  user90: 'Withdrawal Successful',
  user91: 'Forgot your password?',
  user92: 'Please enter a new password (8-16 letters+numbers)',
  user93: 'Please enter the email verification code',
  user94: 'Get Verification Code',
  user95: 'Get verification code again',
  user96: 'Incorrect Verification Code',
  user97: 'Back Login',
  user98: 'Please enter your username or user ID',
  user99: 'Please enter the confirmation password',
  user100: 'Please enter the invitation code (not required)',
  user101: 'Read and accept the',
  user102: 'Terms of Service',
  user103: 'and',
  user104: 'Privacy Policy',
  user105: 'Reset Password',
  user106: 'Trading Account ID',
  user107: 'Trading Account Password',
  user108: 'Transfer to Trading Account',
  user109: 'Transfer to Cash Account',
  user110: 'Your trading password has been reset',
  user111: 'Please enter your login password',
  user112: 'Confirm Trading Password',
  user113: 'USDT Wallet Address',
  user114: 'Please enter your login password',
  user115: 'Transfer Direction',
  user116: 'Enter login password for verification',
  user117: 'Transferable Amount',
  user118: 'Recipient Username',
  user119: 'Transfer Rules',
  user120: 'Please confirm that the recipient username matches the actual recipient. If not, confirm the recipient ID before transferring.',
  user121: 'Transfers take effect immediately after submission. Please proceed carefully.',
  user122: 'Confirm the account, direction, and amount before submitting',
  user123: 'Insufficient trading account balance',
  user124: 'Insufficient cash account balance',
  user125: 'Please enter a valid withdrawal amount',
  usermoney1: 'English',
  usermoney2: 'Log Out',
  usermoney3: 'My Funds',
  usermoney4: 'Deposit',
  usermoney5: 'Deposit Report',
  usermoney6: 'Cash Account(MEQ)',
  usermoney7: 'Dollars',
  usermoney8: 'Amount',
  usermoney9: 'Exchange Rate',
  usermoney10: 'Amount({n})',
  usermoney11: 'Deposit Receipt',
  usermoney12: 'Please enter the deposit amount.',
  usermoney13: 'Please enter the deposit receipt information',
  usermoney14: 'Wallet',
  usermoney15: 'Amount',
  usermoney16: 'Receiving Bank',
  usermoney17: 'Account Holder',
  usermoney18: 'Bank Name',
  usermoney19: 'Card Account Number',
  usermoney20: 'Submit',
  usermoney21: 'Submission Successful',
  usermoney22: 'The order will be reviewed and processed within 1-2 business days',
  usermoney23: 'Confirm',
  usermoney24: 'Transfer successful',
  usermoney25: 'Transfer',
  usermoney26: 'Transfer Report',
  usermoney27: 'Transfer Type',
  usermoney28: 'Trading Account Transfer',
  usermoney29: 'Transfer to the agent',
  usermoney30: 'Transfer Operation',
  usermoney31: 'Transfer to trading account',
  usermoney32: 'Transfer to cash account',
  usermoney33: 'Recipient Agent ID',
  usermoney34: 'Please enter the agent ID',
  usermoney35: 'Recipient Username',
  usermoney36: 'Trading Account',
  usermoney37: 'DT',
  usermoney38: 'LTT',
  usermoney39: 'Dollars',
  usermoney40: 'Cash Account Balance',
  usermoney41: 'Trading Account balance',
  usermoney42: 'Amount',
  usermoney43: 'Please enter your transfer amount',
  usermoney44: 'Submit',
  usermoney45: 'Transfer Successful',
  usermoney46: 'Confirm',
  usermoney47: 'Withdrawal',
  usermoney48: 'Withdrawal Report',
  usermoney49: 'Cash Account Balance',
  usermoney50: 'Dollars',
  usermoney51: 'Withdrawal Amount',
  usermoney52: 'Please enter your Withdrawal Amount',
  usermoney53: 'Exchange Rate',
  usermoney54: 'Amount(X)',
  usermoney55: 'Receiving Bank',
  usermoney56: 'Submission Successful',
  usermoney57: 'The order will be reviewed and processed within 1-2 business days',
  usermoney58: 'Confirm',
  usermoney59: 'Reminder',
  usermoney60: 'You have not yet verified your bank card information. Please complete the bank card information before withdrawal.',
  usermoney61: 'Cancel',
  usermoney62: 'Complete Immediately',
  usermoney63: 'Submit',
  usermoney64: 'Net P/L',
  usermoney65: 'USDT Address',
  usermoney66: 'wallet address QR code',
  usermoney67: 'Introduction to Meta Equity',
  usermoney68: 'HeyMeta’s base currency is Meta Equity (MEQ). MEQ is pegged 1:1 to Tether (USDT) and can be used for deposits, transfers, trading-account transfers, and ecosystem rights settlement.',
  usermoney69: 'P&L',
  usermoney70: 'MEQ is pegged 1:1 to USDT',
  usermoney71: 'Used for deposits, transfers, and trading-account transfers',
  usermoney72: 'Amounts are subject to the real-time system exchange rate',
  usermoney73: 'Confirm the wallet network and address before submitting',
  usermoney74: 'On-chain arrival time depends on network confirmations',
  usermoney75: 'The platform will never ask for your mnemonic or private key',
  usermoney76: 'Do not disclose account information to strangers',
  usermoney77: 'Completed transfers can be viewed in Fund Streams',
  usermoney78: 'The transaction hash cannot be changed after submission',
  usermoney79: 'Contact online support if you have questions',
  usermoney80: 'Security Notice',
  userstatement1: 'English',
  userstatement2: 'Log Out',
  userstatement3: 'Report',
  userstatement4: 'Deposit Report',
  userstatement5: 'Transfer Type',
  userstatement6: 'All',
  userstatement7: 'Bank Deposit',
  userstatement8: 'Trading Account Transfer',
  userstatement9: 'Status',
  userstatement10: 'All',
  userstatement11: 'Pending Approval',
  userstatement12: 'Approval Successful',
  userstatement13: 'Approval Unsuccessful',
  userstatement14: 'Deposit Time',
  userstatement15: 'Search',
  userstatement16: 'Export',
  userstatement17: 'Reference No',
  userstatement18: 'Amount(X)',
  userstatement19: 'Amount($)',
  userstatement20: 'Exchange Rate',
  userstatement21: 'Cash Account balance($)',
  userstatement22: 'Actual Deposit',
  userstatement23: 'Transfer Type',
  userstatement24: 'Deposit Time',
  userstatement25: 'Deposit Receipt',
  userstatement26: 'Deposit ID',
  userstatement27: 'Remark',
  userstatement28: 'Status',
  userstatement29: 'Operate',
  userstatement30: 'Details',
  userstatement31: 'Close',
  userstatement32: 'Total X results',
  userstatement33: 'x items/page',
  userstatement34: 'Jump To Page X',
  userstatement35: 'Withdrawal Report',
  userstatement36: 'Status',
  userstatement37: 'All',
  userstatement38: 'Pending Approval',
  userstatement39: 'Approval Successful',
  userstatement40: 'Approval Unsuccessful',
  userstatement41: 'Withdrawal Time',
  userstatement42: 'Search',
  userstatement43: 'Reference No',
  userstatement44: 'Amount(X)',
  userstatement45: 'Amount($)',
  userstatement46: 'Exchange Rate',
  userstatement47: 'Cash Account balance($)',
  userstatement48: 'Withdrawal  Time',
  userstatement49: 'Remark',
  userstatement50: 'Status',
  userstatement51: 'Operate',
  userstatement52: 'Details',
  userstatement53: 'Status',
  userstatement54: 'Close',
  userstatement55: 'Total X results',
  userstatement56: 'x items/page',
  userstatement57: 'Jump To Page X',
  userstatement58: 'Trading Account Transfer Records',
  userstatement59: 'Trading Account',
  userstatement60: 'All',
  userstatement61: 'DT',
  userstatement62: 'LTT',
  userstatement63: 'Transfer  Time',
  userstatement64: 'Search',
  userstatement65: 'Reference No',
  userstatement66: 'Amount($)',
  userstatement67: 'Amount(X)',
  userstatement68: 'Exchange Rate',
  userstatement69: 'Trading Account',
  userstatement70: 'Trading Account Balance',
  userstatement71: 'Transfer  Time',
  userstatement72: 'Total X results',
  userstatement73: 'x items/page',
  userstatement74: 'Jump To Page X',
  userstatement75: 'Agent Transfer Report',
  userstatement76: 'Transfer Type',
  userstatement77: 'All',
  userstatement78: 'Deposit',
  userstatement79: 'Withdrawal',
  userstatement80: 'Transfer Time',
  userstatement81: 'Search',
  userstatement82: 'Reference No',
  userstatement83: 'Agent ID',
  userstatement84: 'Please enter the agent ID',
  userstatement85: 'Amount($)',
  userstatement86: 'Cash Account balance($)',
  userstatement87: 'Transfer Type',
  userstatement88: 'Transfer Time',
  userstatement89: 'Total X results',
  userstatement90: 'x items/page',
  userstatement91: 'Jump To Page X',
  userstatement92: 'Trading Report',
  userstatement93: 'Filled Time',
  userstatement94: 'Open / Close',
  userstatement95: 'Open',
  userstatement96: 'Close',
  userstatement97: 'Buy / Sell',
  userstatement98: 'Buy',
  userstatement99: 'Sell',
  userstatement100: 'All',
  userstatement101: 'Symbol',
  userstatement102: 'Please enter the symbol',
  userstatement103: 'Search',
  userstatement104: 'Export',
  userstatement105: 'Total Profit',
  userstatement106: 'Reference No',
  userstatement107: 'Symbol',
  userstatement108: 'Fill Price',
  userstatement109: 'Open / Close',
  userstatement110: 'Buy / Sell',
  userstatement111: 'Quantity',
  userstatement112: 'Fee({n})',
  userstatement113: 'Profit',
  userstatement114: 'Filled Time',
  userstatement115: 'Total X results',
  userstatement116: 'x items/page',
  userstatement117: 'Jump To Page X',
  userstatement118: 'Long-term Trade Report',
  userstatement119: 'Filled time',
  userstatement120: 'Open / Close',
  userstatement121: 'Open',
  userstatement122: 'Close',
  userstatement123: 'Buy/Sell',
  userstatement124: 'Buy',
  userstatement125: 'Sell',
  userstatement126: 'All',
  userstatement127: 'symbol',
  userstatement128: 'Please enter the symbol',
  userstatement129: 'Search',
  userstatement130: 'Export',
  userstatement131: 'Total Profit',
  userstatement132: 'Order Number',
  userstatement133: 'Symbol',
  userstatement134: 'Cost Price',
  userstatement135: 'Open / Close',
  userstatement136: 'Buy/Sell',
  userstatement137: 'Quantity',
  userstatement138: 'Fee({n})',
  userstatement139: 'Profit',
  userstatement140: 'Execution Time',
  userstatement141: 'Total X results',
  userstatement142: 'x items/page',
  userstatement143: 'Jump To Page X',
  public1: 'Fund review',
  public2: 'Sub-gent Withdrawal Audit',
  public3: 'Sub-gent Earning Report',
  public4: 'User Details',
  public5: 'Personal information',
  public6: 'Fund Management',
  public7: 'Customer Management',
  public8: 'Please enter your user name',
  public9: 'This user name is already in use',
  public10: 'please input your email',
  public11: 'The email format is wrong, please refill',
  public12: 'The password length cannot be less than 8 characters',
  public13: 'Password length cannot be greater than 16 characters',
  public14: 'Must contain both numbers and letters',
  public15: 'Sub-agent created successfully',
  public16: 'Successfully modified',
  public17: 'Please Choose',
  public18: 'All',
  public19: 'Approved',
  public20: 'please enter',
  public21: 'created successfully',
  public22: 'Start',
  public23: 'End',
  public24: 'Please Choose Trading Account',
  public25: 'Total commission',
  public26: 'Add Customer',
  public27: 'The content has been copied to clipboard',
  public28: 'Continue',
  public29: 'Please enter the number',
  public30: 'The minimum deposit amount is $10',
  public31: 'Please enter Swift Code',
  public32: 'Activation Failed',
  public33: 'Upload Files',
  public34: 'Waiting for Activation',
  public35: 'Activated',
  public36: 'Activation Failed',
  public37: 'Your personal profile is not yet verified, and you can only make a deposit after verification',
  public38: 'Exchange Rates',
  public39: 'Forgot Password?',
  public40: 'Verification code sent',
  public41: 'please enter verification code',
  public42: 'Don\'t have an account yet?',
  public43: 'Please enter a mobile phone number (optional)',
  public44: 'Invitation code (optional)',
  public45: 'Already have an account?',
  public46: 'Swipe to the right',
  public47: 'Please enter the phone number',
  public48: 'please enter password again',
  public49: 'The passwords entered twice do not match',
  public50: 'Reset Trading Account Password',
  public51: 'Trading Account Usable Fund',
  public52: 'Exchange Rate',
  public53: 'Modify ID card',
  public54: 'Please upload the front of your ID card',
  public55: 'Please upload the reverse side of your ID card',
  public56: 'Your authentication information has been submitted',
  public57: 'Submitted successfully',
  public58: 'Modify email',
  public59: 'Please enter a new email address',
  public60: 'submit certification',
  public61: 'Please enter the bank card number',
  public62: 'Your authentication information has been submitted',
  public63: 'The uploaded image size cannot exceed 2MB',
  public64: 'upload',
  public65: 'To-do list',
  public66: 'Agent deposit pending approval',
  public67: 'User deposit pending approval',
  public68: 'Agent withdrawal pending approval',
  public69: 'User withdrawal pending approval',
  public70: 'User information pending approval',
  public71: 'Amount(MEQ)',
  public72: 'Trading Account ID',
  public73: 'Log In',
  public74: 'The ratio has been successfully modified',
  public75: 'Bank Information changed successfully',
  public76: 'Password changed successfully',
  public77: 'Sign Up',
  public78: 'The username or user ID you entered does not exist',
  public79: 'Trading Account ID',
  public80: 'Long-Term Trade (LTT)',
  public81: 'MEQ to USDT Exchange Rate',
  public82: 'Type',
  public83: 'Title',
  public84: 'Time',
  public85: 'System Notice',
  public86: 'Fund Notice',
  public87: 'Trading Notice',
  public88: 'Campaign Notice',
  public89: 'Read',
  public90: 'Unread',
  text1: 'Meta Equity (MEQ)',
  text2: 'Transaction Hash',
  text3: 'Please enter the USDT amount',
  text4: 'Email verification code',
  text5: 'Please enter the withdrawal USDT address',
  text6: 'Bonus Incentive Report',
  text7: 'Claim Risk Compensation Bonus',
  text8: 'Use Risk Compensation Bonus',
  text9: 'Total Bonus (MEQ-A)',
  text10: 'Bonus Balance (MEQ-A)',
  text11: 'Pending Bonus (MEQ-A)',
  text12: 'Manual Claim',
  text13: 'Auto Claim',
  text14: 'Transaction Number',
  text15: 'Total Assets(MEQ)',
  text16: 'Bonus Amount (MEQ-A)',
  text17: 'Claim Ratio',
  text18: 'Bonus Balance (MEQ-A)',
  text19: 'Distribution Time',
  text20: 'Claim Time',
  text21: 'Bonus Claim Method',
  text22: 'Used Bonus (MEQ-A)',
  text23: 'Deductible Bonus (MEQ-A)',
  text24: 'Use Bonus',
  text25: 'Transaction Number',
  text26: 'Deductible Bonus Amount (MEQ-A)',
  text27: 'Bonus Balance (MEQ-A)',
  text28: 'Current Cash Account Balance (MEQ)',
  text29: 'Generation Time',
  text30: 'Usage Time',
  text31: 'Description',
  text32: '1. Eligibility:',
  text33: '(1) Users who complete registration and meet the platform rules may participate in the bonus incentive program;',
  text34: '(2) Bonuses are calculated and distributed based on account assets, deposit status, campaign rules, and system records;',
  text35: '(3) Calculation methods, rates, and distribution times are subject to platform announcements and system records;',
  text36: '(4) Bonuses are used only as benefit credits or risk-buffer tools and do not constitute withdrawable funds.',
  text37: '(5) Users can manually claim every week, and they can claim multiple new coins at once, or set up automatic claiming.',
  text38: '2.Usage Rules:',
  text39: '(1) New coins in the credit account are used to offset trading losses;',
  text40: '(2) If the new coin balance in the credit account is less than the trading loss amount, the available amount in the credit account will be used first, and the remaining loss amount will be carried forward.',
  text41: 'Pending use',
  text42: 'Used',
  text43: 'Automatic claim',
  text44: 'Manual claim',
  text45: 'Risk Compensation Overview',
  text46: 'Risk Compensation Claim Records',
  text47: 'Risk Compensation Offset Records',
  text48: 'Risk Compensation Commission Details',
  text49: 'Claim time',
  text50: 'Claim method',
  text51: 'Upline agent',
  text52: 'Calculation time',
  text53: 'Total bonus amount',
  text54: 'Used bonus amount',
  text55: 'Total used bonus amount',
  text56: 'Bonus commission ratio(%)',
  text57: 'Commission(MEQ)',
  text58: 'Total commission amount',
  text59: 'Wallet Address',
  text60: 'Wallet Type',
  text61: 'Edit Mnemonic',
  text62: 'Your initial mnemonic has been generated:',
  text63: 'Mnemonic',
  text64: 'Please enter the mnemonic',
  text65: 'Please enter letters or numbers',
  text66: 'Received',
  text67: 'MEQ',
  text68: 'More',
  text69: '<h3>1. What Is the HeyMeta Bonus Incentive Program?</h3>\n<p>The HeyMeta Bonus Incentive Program consists of Daily Growth Bonus (MEQ-P) and Risk Compensation Bonus (MEQ-A). It is designed to provide long-term incentives and a risk buffer for trading.</p>\n<p>After completing real account activities such as registration, deposits, and trading, users may accumulate MEQ-P according to platform rules. Once activation conditions are met, MEQ-P may be converted into MEQ-A, which can be used to offset eligible trading losses.</p>\n<h3>2. How to Participate</h3>\n<p><strong>① Register an account</strong>: After registration, the system starts recording and accumulating Daily Growth Bonus (MEQ-P).</p>\n<p><strong>② Make a deposit</strong>: Eligible deposits may trigger activation, converting qualifying credits into Risk Compensation Bonus (MEQ-A).</p>\n<p><strong>③ Keep your account active</strong>: Continued trading and ecosystem participation may help unlock more platform benefits.</p>\n<h3>3. Use of Bonuses</h3>\n<p>MEQ-A can only be automatically applied to offset eligible trading losses. It cannot be withdrawn, transferred, or used as trading principal.</p>\n<p>MEQ-P is a pending right without monetary nature and must meet platform rules before activation.</p>\n<h3>4. Risk Disclosure</h3>\n<p>All trading involves risk. Bonuses are risk-buffer tools and do not represent any guarantee of returns or principal protection.</p>\n<p>The platform may identify abnormal activities under risk-control rules and reserves the right to adjust, freeze, or reclaim related benefits.</p>',
  text70: 'Bonus Incentive Rules',
  text71: 'MEQ Reward Ranking Top',
  text72: 'Deposit Amount (MEQ)',
  text73: 'Net Assets After Deposit',
  text74: 'Reward Ratio',
  text75: 'Days',
  text76: 'Reward Amount (MEQ-A)',
  text77: 'Claim Date',
  text78: 'Reward Base Amount',
  text79: 'Bonus Amount (MEQ-P)',
  text80: 'Rewarded MEQ',
  text81: 'Current Reward Base Amount',
  text82: 'Remaining Daily Growth Bonus (MEQ-P)',
  text83: 'Total Daily Growth Bonus Earned (MEQ-P)',
  text183: 'Activatable Growth Bonus (MEQ-P)',
  text84: 'Total MEQ Earned',
  text85: 'Activated Risk Compensation Bonus (MEQ-A)',
  text185: 'Activated Bonus (MEQ-A)',
  text86: 'Activation Amount (MEQ-A)',
  text87: 'Please keep the following mnemonic words safe. They are the only proof of account recovery and should not be leaked or lost',
  text88: 'If necessary, you can also modify it to a more memorable mnemonic for easier account management and recovery in the future',
  text89: 'The mnemonic phrase can only be modified once.',
  text90: 'It must be 10 to 12 characters long and consist of numbers or letters.',
  text91: 'Your new mnemonic phrase is:',
  text92: 'Please keep your mnemonic phrase safe. If you forget your password, you can recover your account using the mnemonic phrase.',
  text93: 'Note: If you forget both your password and mnemonic phrase, your account cannot be recovered.',
  text94: 'Mnemonic words modified successfully',
  text95: 'Gift type',
  text96: 'Transaction bonus',
  text97: 'Activate bonus',
  text98: 'Daily Growth Bonus',
  text99: 'Growth Bonus Overview',
  text100: 'Growth Bonus Claim Records',
  text101: 'Growth Bonus Activation Records',
  text102: 'Activation Records',
  text103: 'Total Daily Growth Bonus Earned (MEQ-P)',
  text104: 'Total MEQ Earned',
  text105: 'Date',
  text106: 'Activated Risk Compensation Bonus (MEQ-A)',
  text107: 'Amount',
  text108: 'Running Lantern Record',
  text109: 'Activation date',
  text110: 'Dividend Ratio',
  text111: 'Dividend Amount',
  text112: 'Deposited To Cash Account',
  text113: 'Current Shares Held',
  text114: 'Total Dividends Earned',
  text115: 'Dividend',
  text116: 'Dividend Records',
  text117: 'Distribution Time',
  text319: 'Risk Compensation Bonus Rules (MEQ-A)',
  text320: '1. Definition',
  text321: '2. Acquisition Methods',
  text322: '3. Usage Rules',
  text323: '4. Restrictions',
  text324: '5. Risk Disclosure',
  text325: '6. Risk Control & Violations',
  text326: '7. Amendments & Final Interpretation',
  text133: 'Risk Compensation Bonus (Active Meta Equity, “MEQ-A”) refers to activated equity credits provided by the platform. It can only be used to offset eligible trading losses under specific conditions and does not constitute user-owned or withdrawable funds.',
  text134: 'Users may obtain MEQ-A through the following methods:',
  text135: '1. Conversion from pending equity.',
  text136: '2. Account balance rewards. The platform may calculate and distribute MEQ-A daily based on the user’s total account assets and applicable rules. Formula:',
  text137: 'MEQ-A = Total Account Assets × Reward Rate',
  text139: '1. MEQ-A can only be used to offset trading losses incurred by the user on the platform.',
  text140: '2. MEQ-A is automatically applied according to system rules when losses occur and cannot be used manually.',
  text141: '3. MEQ-A cannot be used for opening positions, increasing positions, or as margin.',
  text142: 'MEQ-A is a promotional credit and does not possess the nature of funds, subject to the following restrictions:',
  text143: '1. Cannot be withdrawn, transferred, or redeemed;',
  text144: '2. Cannot be used as trading principal or participate in profit distribution;',
  text145: '3. Does not constitute user assets or platform liabilities;',
  text146: '4. Does not generate interest or any form of returns;',
  text147: '5. Does not constitute any guarantee of returns or principal safety by the platform.',
  text148: '1. Users acknowledge that MEQ-A serves only as a risk buffer and does not guarantee any returns.',
  text149: '2. All trading activities involve risks, and users shall make independent decisions and bear their own losses.',
  text150: '3. The platform shall not be liable for any trading losses incurred by users (unless otherwise required by law).',
  text151: '1. If the platform detects arbitrage, bonus abuse, hedging, or other abnormal activities, it has the right to:',
  text152: '(1) Freeze or reclaim MEQ-A;',
  text153: '(2) Disqualify the user from participation;',
  text154: '(3) Pursue legal or contractual liabilities.',
  text155: '2. The platform reserves the right to review abnormal accounts and impose necessary restrictions.',
  text156: '1. The platform reserves the right to modify acquisition methods, usage rules, and related terms.',
  text157: '2. Related adjustments will be published by announcement and take effect from the announcement date.',
  text158: '3. To the extent permitted by law, the platform reserves the final right of interpretation of these rules.',
  text329: 'Daily Growth Bonus Rules (MEQ-P)',
  text330: '1. Definition',
  text331: '2. Distribution Rules',
  text332: '3. Nature of Rights',
  text333: '4. Activation Mechanism',
  text334: '5. Expiry & Handling',
  text335: '6. Rule Amendments',
  text233: 'Daily Growth Bonus (Pending Meta Equity, “MEQ-P”) refers to pending benefit credits granted under platform rules. It does not constitute user-owned assets or withdrawable funds.',
  text234: '1. Users are deemed to participate upon registration.',
  text235: '2. The platform calculates and distributes MEQ-P daily based on reward base and rate.',
  text236: '3. MEQ-P is distributed daily; timing and rate follow system records.',
  text237: '4. MEQ-P can accumulate before activation.',
  text239: 'MEQ-P is a non-activated benefit credit without monetary nature and is subject to the following restrictions:',
  text240: '1. Cannot be used for any form of trading;',
  text241: '2. Cannot be used to offset trading losses;',
  text242: '3. Cannot be withdrawn, transferred, gifted, or redeemed;',
  text243: '4. Does not generate interest or any returns;',
  text244: '5. Does not constitute deposits, assets, or guarantees;',
  text245: '1. When activation conditions set by the platform are met, including but not limited to completing a deposit, MEQ-P will be automatically converted into Risk Compensation Bonus (MEQ-A). Formula:',
  text246: 'Activatable MEQ-P = (Current Deposit - Total Withdrawals Since Last Activation) × Reward Rate × Days',
  text247: '2. Conversion rates, conditions, and detailed rules are subject to the latest platform announcements.',
  text248: '3. After conversion, the corresponding MEQ-P will no longer be retained.',
  text249: '1. If a user’s account shows abnormal activity, violations, or breaches of platform rules, the platform may cancel or clear the user’s MEQ-P benefits.',
  text250: '2. If activation conditions are not met for a long period, the platform may adjust or expire MEQ-P according to operational rules.',
  text251: 'The platform may adjust the distribution standards, calculation methods, and activation rules of MEQ-P based on business needs, and will provide notice through announcements.',
  fundstreams1: 'Fund Streams',
  fundstreams2: 'Reference No.',
  fundstreams3: 'Time',
  fundstreams4: 'Amount Change (MEQ)',
  fundstreams5: 'Cash Balance After (MEQ)',
  fundstreams6: 'Source',
  fundstreams7: 'Description',
  fundstreams8: 'Account Source',
  fundstreams9: 'Wallet',
  fundstreams10: 'Cash Account',
  fundstreams11: 'Trading Account',
  fundstreams12: 'Daily Growth Bonus',
  fundstreams13: 'Risk Compensation Bonus',
  user126: 'Please enter your User Center password',
  transferrecord1: 'Transfer Received',
  transferrecord2: 'Transfer to Others',
  usermenu1: 'Risk Compensation Bonus',
  usermenu2: 'Daily Growth Bonus',
  usermenu3: 'Internal Transfer Records',
  usermenu4: 'Account Transfer Records',
  transferbalance1: 'Insufficient available balance in the cash account. Please adjust the transfer amount.',
  proxytransfer1: 'The recipient user ID you entered does not exist.',
  walletremark1: 'Bonus Commission',
  walletremark2: 'Trading Commission',
  walletremark3: 'Transfer to Cash Account',
  proxybonusgroup1: 'User Growth Bonus Report',
  proxybonusgroup2: 'User Risk Compensation Report',
  usermenu5: 'Enter Trading System',
  promotionCenter: 'Promotion Center',
  membershipCenter: 'Membership Center',
  promotionInviteDisabled: 'Invitation is currently disabled',
  promotionCurrentLevel: 'Current Promotion Level',
  promotionValidStatus: 'Valid User Status',
  promotionValid: 'Valid',
  promotionInvalid: 'Not Yet Valid',
  promotionAutoUpgrade: 'Auto Upgrade',
  promotionEnabled: 'Enabled',
  promotionDisabled: 'Disabled',
  promotionDirectCount: 'Direct Referrals',
  promotionDirectValidCount: 'Valid Direct Referrals',
  promotionTeamCount: 'Total Team Members',
  promotionTeamValidCount: 'Valid Team Users',
  promotionInviteCode: 'Invitation Code',
  promotionInviteLink: 'Invitation Link',
  promotionCopy: 'Copy',
  promotionCopyLink: 'Copy Link',
  promotionScanRegister: 'Scan to Register',
  promotionNextLevel: 'Next Promotion Level',
  promotionRemainingDirect: 'Valid Direct Referrals Needed',
  promotionRemainingTeam: 'Valid Team Users Needed',
  promotionTradeRatesReadonly: 'Trading Commission Rates (Read-only)',
  promotionMemberRatesReadonly: 'Premium Membership Commission Rates (Read-only)',
  promotionLevel3: 'Level 3 Agent',
  promotionLevel2: 'Level 2 Agent',
  promotionLevel1: 'Level 1 Agent',
  promotionMaster: 'Master Agent',
  promotionNormalUser: 'Regular User',
  promotionPremiumMember: 'Premium Member',
  promotionNormalMember: 'Regular Member',
  promotionTeam: 'Promotion Team',
  promotionSearchPlaceholder: 'Username / User ID / Trading Account',
  promotionDirectInvite: 'Direct Referrals',
  promotionAllTeam: 'Entire Team',
  promotionUserId: 'User ID',
  promotionUsername: 'Username',
  promotionLevel: 'Agent Level',
  promotionMemberLevel: 'Membership Level',
  promotionValidUser: 'Valid User',
  promotionYes: 'Yes',
  promotionNo: 'No',
  promotionRegisterTime: 'Registration Time',
  promotionMyCommission: 'My Promotion Commissions',
  promotionTradeCommission: 'Trading Commission',
  promotionMemberCommission: 'Premium Membership Commission',
  promotionTotalCommission: 'Total Commission',
  promotionTradeNo: 'Trade No.',
  promotionCommissionBase: 'Commission Base',
  promotionDifferentialRate: 'Actual Differential Rate',
  promotionCommissionAmount: 'Actual Commission',
  promotionTime: 'Time',
  promotionMemberOrder: 'Membership Order',
  promotionSourceUser: 'Source User',
  promotionCopySuccess: 'Copied successfully',
  promotionCopyFailed: 'Copy failed. Please copy manually.',
  promotionSystemHint: 'The new agent system is enabled. Users register through invitation codes or links, and agent levels are upgraded automatically by the system.',
  membershipDisabled: 'Premium membership is currently disabled',
  membershipCurrentLevel: 'Current Membership',
  membershipCashBalance: 'Cash Account Balance',
  membershipExpireTime: 'Membership Expiry',
  membershipPremium: 'Premium Membership',
  membershipDays: 'days',
  membershipPermanent: 'Permanent',
  membershipRenew: 'Renew Premium Membership',
  membershipUpgrade: 'Upgrade to Premium',
  membershipOrders: 'Purchase Records',
  membershipOrderNo: 'Order No.',
  membershipPaidAmount: 'Paid Amount (MEQ)',
  membershipPeriod: 'Membership Period',
  membershipPurchaseTime: 'Purchase Time',
  membershipConfirmPurchase: 'Use {price} MEQ from the cash account to purchase Premium Membership?',
  membershipConfirmTitle: 'Confirmation',
  membershipPurchaseSuccess: 'Purchase successful',
  promotionDirectLevel3PlusCount: 'Direct Level 3+ Agents',
  promotionDirectLevel2PlusCount: 'Direct Level 2+ Agents',
  promotionUpgradeRequirement: 'Upgrade Requirement',
  promotionRequirementDirectValid: 'Direct Valid Users',
  promotionRequirementDirectLevel3Plus: 'Direct Level 3+ Agents',
  promotionRequirementDirectLevel2Plus: 'Direct Level 2+ Agents',
  promotionCurrentCount: 'Current',
  promotionRequiredCount: 'Required',
  promotionRemainingCount: 'Remaining',
  promotionRiskGiftCommission: 'Risk Bonus Referral Commission',
  promotionGiftAmount: 'Risk Bonus Amount',
  usermenu6: 'Start Trading',
  invitationDetailsV2: 'Invitation Details',
  commissionDetailsV2: 'Commission Details'
}
export default messages
